<template>
  <label :class="$style.checkbox">
    <input type="checkbox" :value="item" v-model="filter[group]" />
    <span :class="$style.checkmark"></span>
    {{ item.title }}
  </label>
</template>

<script>
export default {
  name: 'CasesCheckbox',
  props: {
    item: Object,
    filter: Object,
    group: String,
  },
};
</script>

<style module lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;

.checkbox {
  @include mixins.font(1.6rem, 1);

  position: relative;
  display: block;
  padding: 6px 0 0 22px;
  cursor: pointer;
  transition: color 0.3s;
  user-select: none;
  white-space: nowrap;

  &:hover {
    color: #000;
    transition: color 0.3s;
  }

  & + .checkbox {
    margin-top: 10px;
  }

  input {
    @include mixins.size(0);

    position: absolute;
    cursor: pointer;
    opacity: 0;

    &:checked ~ .checkmark {
      background-image: url("data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.62451 5.65729L6.31515 9.758L11.8511 3.60693' stroke='%231D1D1F' stroke-width='2' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
    }

    &:checked ~ .checkmark::after {
      display: block;
    }
  }

  .checkmark {
    @include mixins.size(14px);

    position: absolute;
    top: 6.5px;
    left: 0;
    background-color: #f2f1f7;
    border-radius: 3px;

    &::after {
      position: absolute;
      display: none;
      content: '';
    }
  }
}
</style>
